import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import nb from "./Images/neobot.gif";

function NeoBot() {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

const SILENCE_THRESHOLD = 0.01; // adjust as needed


  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const intervalIdRef = useRef(null);
  const greetedRef = useRef(false);

  // control the audio loop
  const isRecordingRef = useRef(false);
  const shouldRestartRef = useRef(true); // set false when paused (e.g., waiting for file load)

  const [greeting, setGreeting] = useState("");
  const [faceStatus, setFaceStatus] = useState("");
  const [recordingStatus, setRecordingStatus] = useState("");
  const [convertedText, setConvertedText] = useState("");
  const [error, setError] = useState("");
  const [fileResults, setFileResults] = useState({});
  const [folderResults, setFolderResults] = useState([]);
  const [openedFile, setOpenedFile] = useState(null); // {matched_name, url, mimeType, ...}

  const folderUrl =
    "https://drive.google.com/drive/folders/12To_p9CK2cLHnQhNjRL8sPba4tFCMI0T";

  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Speak helper
  const speakAndWait = (text) =>
    new Promise((resolve) => {
      const utter = new SpeechSynthesisUtterance(text);
      utter.onend = () => resolve();
      speechSynthesis.speak(utter);
    });

  const scheduleRestart = (ms = 2000) => {
    if (!shouldRestartRef.current) return;
    setTimeout(() => recordAudioAndConvert(), ms);
  };

  //  Record audio and send to backend
const recordAudioAndConvert = async () => {
  if (isRecordingRef.current) return; // avoid overlap
  isRecordingRef.current = true;

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    const audioChunks = [];

    setRecordingStatus("Recording...");
    setConvertedText("");
    setError("");

    mediaRecorder.ondataavailable = (e) => audioChunks.push(e.data);

    mediaRecorder.onstop = async () => {
      // === NEW: Silence detection ===
      const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
      const arrayBuffer = await audioBlob.arrayBuffer();
      const audioCtx = new AudioContext();
      const decoded = await audioCtx.decodeAudioData(arrayBuffer);

      const channelData = decoded.getChannelData(0);
      const rms =
        Math.sqrt(
          channelData.reduce((acc, val) => acc + val * val, 0) /
            channelData.length
        );

if (rms < SILENCE_THRESHOLD) {
  setRecordingStatus("Silence detected, stopping.");
  isRecordingRef.current = false;
  stream.getTracks().forEach((t) => t.stop());

  // Instead of stopping forever, schedule a retry
  shouldRestartRef.current = true; 
  scheduleRestart(2000); // retry after 2 sec
  return;
}
      // === END silence detection ===

      setRecordingStatus("Uploading audio...");

      const formData = new FormData();
      const userPath = `/var/www/myflaskapp/flask_static/${userEmail}/NeoBot`;
      formData.append("audio", audioBlob, "recorded_audio.wav");
      formData.append("path", userPath);

      let localShouldRestart = true; // will be false if waiting for file load

      try {
        const uploadRes = await fetch("/upload_audio", {
          method: "POST",
          body: formData,
        });
        const uploadData = await uploadRes.json();

        const speechForm = new FormData();
        speechForm.append("path", uploadData.converted_path);

        const speechRes = await fetch("/NEOSPEECHTOTXT", {
          method: "POST",
          body: speechForm,
        });
        const speechData = await speechRes.json();

        if (speechRes.ok && speechData.original_text) {
          const textRaw =
            (speechData.original_text || "").toLowerCase().trim();
          setConvertedText(textRaw);
          setRecordingStatus("Transcription complete");

            // Regex intent parse (extended)
            const openMatch = textRaw.match(
              /\b(open|open up|show|display|run|download)\s+(.+)/i
            );
            const showMatch = textRaw.match(/\b(show|display|list)\s+(.+)/i);
            const closeMatch = textRaw.match(/\b(close|close the file)\b/i);

            // NLP parsing
            let verbs = [];
            let nouns = [];
            try {
              const nlpRes = await fetch("/nlpapi", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ text: speechData.original_text }),
              });
              const nlpData = await nlpRes.json();
              verbs = (nlpData.verbs || []).map((v) => String(v).toLowerCase());
              nouns = (nlpData.nouns || []).map((n) => String(n).toLowerCase());
            } catch (nlpErr) {
              console.warn("NLP error, fallback only:", nlpErr);
            }

 // ---------- INTENT HANDLERS ----------
const wantsOpen =
  (verbs &&
    verbs.some((v) =>
      ["open", "show", "bring", "download", "draw", "bring up", "display", "run", "show me", "help me with", "i need", "we need", "help us with", "drawing"].includes(v)
    )) ||
  !!openMatch;

const wantsShow =
  (verbs &&
    verbs.some((v) =>
      ["show", "display", "bring", "bring up", "draw", "show me", "help me with", "i need", "we need", "help us with", "drawing"].includes(v)
    )) ||
  !!showMatch;

const wantsClose =
  (verbs && verbs.includes("close")) || !!closeMatch;

// ---------- EXTRA OBJECT KEYWORDS ----------
const objectWords = [
  "mould", "mold", "manual", "picking", "operations", "tools", "plf", "hydax",
  "pdf", "inspection", "aluminium", "report", "invoice", "laser", "welding",
  "50", "100", "200", "300", "400", "500", "machine", "machinery", "air",
  "guage", "assem", "assembly", "catalogue", "brochure", "exploded", "explode",
  "bearing", "brouching", "body", "cover", "final", "initial", "cnc",
  "maintenance", "check", "checklist", "egico", "electrical", "fire", "training",
  "document", "documentation", "flexible", "shaft", "grinder", "grind", "gear",
  "hobbing", "ratio", "calculation", "procedure", "google", "site", "process",
  "chart", "revision", "hub", "shipping", "label", "sintered", "bronze",
  "filter", "six", "sigma", "guide", "flat", "round", "tap", "scanner",
  "spares", "loctite", "hy", "mandrill", "manifest"
];

// ---------- DETECTION LOGIC ----------

// Try to match spoken nouns against objectWords
const matchedObject = nouns.find((n) => objectWords.includes(n.toLowerCase()));

// CLOSE
if (wantsClose && openedFile) {
  setRecordingStatus("Closing file�");
  setOpenedFile(null);
  shouldRestartRef.current = false; // pause auto-restart
  localShouldRestart = false;

  // Speak "Thank you. Do you want another document?"
  await speakAndWait("Thank you. Do you want another document?");

  // Listen for Yes/No response
  try {
    const stream2 = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder2 = new MediaRecorder(stream2);
    const audioChunks2 = [];

    mediaRecorder2.ondataavailable = (e) => audioChunks2.push(e.data);

    mediaRecorder2.onstop = async () => {
      const audioBlob2 = new Blob(audioChunks2, { type: "audio/wav" });
      const formData2 = new FormData();
      formData2.append("audio", audioBlob2, "response.wav");
      formData2.append("path", `/var/www/myflaskapp/flask_static/${userEmail}/NeoBot`);

      try {
        const uploadRes2 = await fetch("/upload_audio", {
          method: "POST",
          body: formData2,
        });
        const uploadData2 = await uploadRes2.json();

        const speechForm2 = new FormData();
        speechForm2.append("path", uploadData2.converted_path);

        const speechRes2 = await fetch("/NEOSPEECHTOTXT", {
          method: "POST",
          body: speechForm2,
        });
        const speechData2 = await speechRes2.json();

        if (speechRes2.ok && speechData2.original_text) {
          const responseText = speechData2.original_text.toLowerCase().trim();

          if (responseText.includes("yes")) {
            await speakAndWait("Okay, please tell me the document name.");
            shouldRestartRef.current = true;
            recordAudioAndConvert(); // restart loop
         } else if (responseText.includes("no")) {
  await speakAndWait("Thanks, have a good day.");
  shouldRestartRef.current = false; // stop audio loop

  // Reset after 5 seconds and restart face matching
  setTimeout(() => {
    // Reset all states
    setOpenedFile(null);
    setFileResults({});
    setFolderResults([]);
    setConvertedText("");
    setGreeting("");
    setFaceStatus("");
    greetedRef.current = false;

    // Restart camera and face detection
    startVideo();
    intervalIdRef.current = setInterval(detectFaceAndGreet, 3000);
  }, 5000);
}else {
            await speakAndWait("I didn't understand. Let's continue.");
            shouldRestartRef.current = true;
            recordAudioAndConvert();
          }
        }
      } catch (err2) {
        console.error("Error in Yes/No listening:", err2);
        await speakAndWait("Error processing response, continuing.");
        shouldRestartRef.current = true;
        recordAudioAndConvert();
      } finally {
        stream2.getTracks().forEach((t) => t.stop());
      }
    };

    mediaRecorder2.start();
    setTimeout(() => mediaRecorder2.stop(), 4000); // listen 4 sec for yes/no
  } catch (micErr2) {
    console.error("Mic error for yes/no:", micErr2);
    await speakAndWait("Couldn't capture your response, continuing.");
    shouldRestartRef.current = true;
    recordAudioAndConvert();
  }
}
// OPEN (file)
else if (wantsOpen) {
  const candidate =
    (openMatch && openMatch[2]) ||
    (matchedObject ? matchedObject : (nouns.length > 0 ? nouns.join(" ") : ""));

  if (candidate) {
    setRecordingStatus("Loading file�");
    setError("");
    shouldRestartRef.current = false;
    localShouldRestart = false;

    const openRes = await fetch("/openfile", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filtered_text: candidate,
        folder_url: folderUrl,
      }),
    });

    const openData = await openRes.json();
    if (openData.success) {
      setOpenedFile(null); // reset first
      setOpenedFile(openData);
    } else {
      setError(openData.error || "File not found");
      shouldRestartRef.current = true;
      localShouldRestart = true;
    }
  }
}
// SHOW (list files/folders)
else if (wantsShow) {
  const spokenText = speechData.original_text.toLowerCase(); // full recognized text

  const listAllKeywords = ["document", "documents", "file", "files", "everything", "all"];

  // If any of the list-all keywords appear anywhere in the spoken text, fetch all
  const shouldListAll = listAllKeywords.some((kw) => spokenText.includes(kw));

  if (shouldListAll) {
    // fetch ALL files
    const searchRes = await fetch("/filesearch", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filtered_text: "",   // empty = fetch all
        folder_url: folderUrl,
      }),
    });

    const searchData = await searchRes.json();
    if (searchData.success) {
      setFileResults(searchData.matches);
      setFolderResults(searchData.folders);

      // Optional: speak number of files/folders
      const fileCount = Object.values(searchData.matches).flat().length;
      const folderCount = searchData.folders.length;
      await speakAndWait(`I found ${fileCount} files and ${folderCount} folders.`);
    } else {
      setError(searchData.error || "Search failed");
    }
  } else {
    // normal filtered search
    const query =
      (showMatch && showMatch[2]) ||
      (matchedObject ? matchedObject : (nouns.length > 0 ? nouns[0] : ""));
    
    if (query) {
      const searchRes = await fetch("/filesearch", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filtered_text: query,
          folder_url: folderUrl,
        }),
      });

      const searchData = await searchRes.json();
      if (searchData.success) {
        setFileResults(searchData.matches);
        setFolderResults(searchData.folders);
      } else {
        setError(searchData.error || "Search failed");
      }
    } else {
      setError("Couldn't detect what to show");
    }
  }
}
else {
  setRecordingStatus("No command detected, continuing�");
  await speakAndWait("Sorry, I was not programmed for your command, please talk to my developer.");
}
            // ---------- END INTENT ----------
               } else {
          setError(speechData.error || "Speech recognition failed");
        }
      } catch (err) {
        console.error("Audio processing error:", err);
        setError("Processing error");
      } finally {
        stream.getTracks().forEach((track) => track.stop());
        isRecordingRef.current = false;
        shouldRestartRef.current = localShouldRestart;
        scheduleRestart(2000);
      }
    };

    mediaRecorder.start();
    setTimeout(() => mediaRecorder.stop(), 5000);
  } catch (err) {
    console.error("Mic error:", err);
    setError("Microphone access denied.");
    isRecordingRef.current = false;
    scheduleRestart(2000);
  }
};
  // Face detection + greeting
  const detectFaceAndGreet = async () => {
    if (greetedRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const base64Image = canvas.toDataURL("image/png").split(",")[1];
    const payload = {
      frame: base64Image,
      userEmail,
      savePath: `/var/www/myflaskapp/flask_static/${userEmail}/NeoBot/Images`,
      sqlQuery: "SELECT pic, name FROM neobot",
      filename: "test.png",
    };

    try {
      const res = await fetch("/NeoFACERECGAPI", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.message.includes("Matched") && !greetedRef.current) {
        greetedRef.current = true;
        setFaceStatus("Face matched");
        stopCamera();
        const name =
          data.matched_name || data.message.replace("Matched ", "");
// ? Add "Hi" before the name
  await speakAndWait(`Hi ${name}`);


        // Fetch greeting
        const greetRes = await fetch("/GREETAPI");
        const greetings = await greetRes.json();
        const hour = new Date().getHours();
        const type =
          hour < 12 ? "morning" : hour < 15 ? "afternoon" : "evening";
        const selectedGreeting = greetings[type];

        setGreeting(selectedGreeting);
        await speakAndWait(selectedGreeting);

        shouldRestartRef.current = true;
        recordAudioAndConvert();
      } else {
        setFaceStatus("No match found");
      }
    } catch (err) {
      console.error("Face API error:", err);
    }
  };

  // Start/stop camera
  const startVideo = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      streamRef.current = stream;
    } catch (err) {
      console.error("Webcam error:", err);
    }
  };

  const stopCamera = () => {
    if (streamRef.current)
      streamRef.current.getTracks().forEach((t) => t.stop());
    if (intervalIdRef.current) clearInterval(intervalIdRef.current);
  };

  useEffect(() => {
    startVideo();
    intervalIdRef.current = setInterval(detectFaceAndGreet, 3000);
    return () => stopCamera();
  }, []);

  const handleViewerLoaded = () => {
    setRecordingStatus("File loaded");
    shouldRestartRef.current = true;
    scheduleRestart(1500);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Welcome to NEOBOT MANUFACTURING</h1>
      <p>Signed in as: {userEmail}</p>
      {greeting && <h2>{greeting}</h2>}

      {/* Camera + Canvas */}
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <video
          ref={videoRef}
          autoPlay
          muted
          style={{ width: "100px", height: "100px", border: "1px solid black" }}
        />
        <canvas
          ref={canvasRef}
          width="640"
          height="480"
          style={{ width: "100px", height: "100px", border: "1px solid red" }}
        />
      </div>

      {/* Info Panel */}
      <div
        style={{
          position: "absolute",
          top: "120px",
          right: "10px",
          width: "350px",
          maxHeight: "400px",
          backgroundColor: "#fff",
          color: "#000",
          overflowY: "auto",
          padding: "10px",
          borderRadius: "8px",
          fontSize: "14px",
          zIndex: 999,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >
        {faceStatus && (
          <p>
            <strong>Face Detection:</strong> {faceStatus}
          </p>
        )}
        {recordingStatus && (
          <p>
            <strong>Status:</strong> {recordingStatus}
          </p>
        )}
        {error && (
          <p style={{ color: "red" }}>
            <strong>Error:</strong> {error}
          </p>
        )}
        {convertedText && (
          <p>
            <strong>Speech-to-Text:</strong> {convertedText}
          </p>
        )}

        {/* NLP-driven File Search Results */}
        {Object.keys(fileResults).length > 0 && (
          <div>
            <h4>?? Files:</h4>
            {Object.entries(fileResults).map(([folderPath, files]) => (
              <div key={folderPath}>
                <p>
                  <strong>{folderPath}</strong>
                </p>
                <ul>
                  {files.map((f, idx) => (
                    <li key={idx}>{f.name}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {folderResults.length > 0 && (
          <div>
            <h4>?? Subfolders:</h4>
            <ul>
              {folderResults.map((f, idx) => (
                <li key={idx}>
                  {f.name} ({f.path})
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Opened File Viewer */}
        {openedFile && (
          <div style={{ marginTop: "10px" }}>
            <h4>?? Opened File: {openedFile.matched_name}</h4>
            {openedFile.mimeType === "application/pdf" ? (
              <iframe
                title="pdf-viewer"
                src={openedFile.url}
                style={{
                  width: "100%",
                  height: "300px",
                  border: "1px solid #ccc",
                }}
                onLoad={handleViewerLoaded}
              />
            ) : openedFile.mimeType.startsWith("image/") ? (
              <img
                src={openedFile.url}
                alt={openedFile.matched_name}
                style={{ maxWidth: "100%", maxHeight: "300px" }}
                onLoad={handleViewerLoaded}
                onError={() => {
                  setError("Failed to load image");
                  shouldRestartRef.current = true;
                  scheduleRestart(1500);
                }}
              />
            ) : openedFile.mimeType.startsWith("video/") ? (
              <iframe
                title="video-viewer"
                src={openedFile.url}
                style={{
                  width: "100%",
                  height: "300px",
                  border: "1px solid #ccc",
                }}
                allow="autoplay"
                onLoad={handleViewerLoaded}
              />
            ) : (
              <p>Unsupported file type</p>
            )}
          </div>
        )}
      </div>

      {/* NeoBot Image */}
      <div>
        <img src={nb} alt="NeoBot" width="500" height="400" />
      </div>
    </div>
  );
}

export default NeoBot;

